module.exports = __webpack_public_path__ + "img/mlogo.2373bda2.png";